<template>
  <footer class="footer-container">
    <div>主办单位：集友科技创新（深圳）有限公司</div>
    <div>地址：深圳市福田区梅林街道梅都社区中康路136号深圳新一代产业园5栋1101-1206</div>
    <div>ICP主体备案号<a target="_blank" href="https://beian.miit.gov.cn">粤ICP备2023001811号</a></div>
  </footer>
</template>

<script>
export default {
  name: 'home-footer'
}
</script>

<style scoped lang="less">
  .footer-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.7);
    height: 100px;
    padding-left: 30%;
    font-size: 16px;
    color: #FFFFFF;
    a {
      color: #999999;
    }
  }
</style>